(function() {
    function formatProduct(prd) {
        var product = null;

        if (prd.product_id && prd.quantity) {
            product = {
                'brand': prd.brand,
                'category': prd.category,
                'coupon': prd.coupon,
                'currency': prd.currency,
                'image_url': prd.image_url,
                'name': prd.name,
                'position': prd.position,
                'price': prd.price,
                'product_id': prd.product_id,
                'quantity': prd.quantity,
                'sku': prd.sku,
                'url': prd.url,
                'variant': prd.variant
            }
        }

        return product;
    }

    function formatProducts(prds) {
        var products = [];
        prds.forEach(function(prd) {
            var product = formatProduct(prd);

            if (product) {
                products.push(product);
            }
        });
        return products;
    }
    
    /* 
     * Subscription Cancellation Intended
     *
     * @listens BLOXSubscriptionCancellationIntended
     * @fires dataLayer#Subscription Cancellation Intended
     */
    window.addEventListener('BLOXSubscriptionCancellationIntended', function(ev) {
        if (window.dataLayer && ev.detail.product) {
            var product = formatProduct(ev.detail.product);
    
            if (product) {
                dataLayer.push({
                    'event': 'Subscription Cancellation Intended',
                    'properties': {
                        'context': ev.detail.context,
                        'current_product': product
                    }
                });
            }
        }
    });
    
    /* 
     * Subscription Cancellation Continued
     *
     * @listens BLOXSubscriptionCancellationContinued
     * @fires dataLayer#Subscription Cancellation Continued
     */
    window.addEventListener('BLOXSubscriptionCancellationContinued', function(ev) {
        if (window.dataLayer && ev.detail.product) {
            var product = formatProduct(ev.detail.product);
    
            if (product) {
                dataLayer.push({
                    'event': 'Subscription Cancellation Continued',
                    'properties': {
                        'context': ev.detail.context,
                        'current_product': product
                    }
                });
            }
        }
    });
    
    /* 
     * Subscription Retention Offers Viewed
     *
     * @listens BLOXSubscriptionRetentionOffersViewed
     * @fires dataLayer#Subscription Retention Offers Viewed
     */
    window.addEventListener('BLOXSubscriptionRetentionOffersViewed', function(ev) {
        if (window.dataLayer && ev.detail.product) {
            var product = formatProduct(ev.detail.product);
    
            if (product) {
                dataLayer.push({
                    'event': 'Subscription Retention Offers Viewed',
                    'properties': {
                        'current_product': product,
                        'products': ev.detail.products
                    }
                });
            }
        }
    });
    
    /* 
     * Subscription Rate Updated
     *
     * @listens BLOXSubscriptionRateUpdated
     * @fires dataLayer#Subscription Rate Updated
     */
    window.addEventListener('BLOXSubscriptionRateUpdated', function(ev) {
        if (window.dataLayer && ev.detail.product) {
            var product = formatProduct(ev.detail.product);
    
            if (product) {
                dataLayer.push({
                    'event': 'Subscription Rate Updated',
                    'properties': {
                        'current_product': product
                    }
                });
            }
        }
    });
    
    /* 
     * Subscription Cancellation Reason Entered
     *
     * @listens BLOXSubscriptionCancellationReasonEntered
     * @fires dataLayer#Subscription Cancellation Reason Entered
     */
    window.addEventListener('BLOXSubscriptionCancellationReasonEntered', function(ev) {
        if (window.dataLayer && ev.detail.product) {
            var product = formatProduct(ev.detail.product);
    
            if (product) {
                dataLayer.push({
                    'event': 'Subscription Cancellation Reason Entered',
                    'properties': {
                        'current_product': product,
                        'cancellation_reason': ev.detail.cancellation_reason
                    }
                });
            }
        }
    });
    
    /* 
     * Subscription Cancellation Confirmed
     *
     * @listens BLOXSubscriptionCancellationConfirmed
     * @fires dataLayer#Subscription Cancellation Confirmed
     */
    window.addEventListener('BLOXSubscriptionCancellationConfirmed', function(ev) {
        if (window.dataLayer && ev.detail.product) {
            var product = formatProduct(ev.detail.product);
    
            if (product) {
                dataLayer.push({
                    'event': 'Subscription Cancellation Confirmed',
                    'properties': {
                        'current_product': product,
                        'cancellation_reason': ev.detail.cancellation_reason
                    }
                });
            }
        }
    });
    
    /* 
     * Subscription Cancellation Retracted
     *
     * @listens BLOXSubscriptionCancellationRetracted
     * @fires dataLayer#Subscription Cancellation Retracted
     */
    window.addEventListener('BLOXSubscriptionCancellationRetracted', function(ev) {
        if (window.dataLayer && ev.detail.product) {
            var product = formatProduct(ev.detail.product);
    
            if (product) {
                dataLayer.push({
                    'event': 'Subscription Cancellation Retracted',
                    'properties': {
                        'current_product': product,
                        'previous_event_name': ev.detail.previous_event_name
                    }
                });
            }
        }
    });
})();